export default __webpack_public_path__ + "static/media/arrow.4ffd95f8.svg";